import React from 'react';
import { Admin, CustomRoutes, Resource, defaultTheme } from 'react-admin';
import authProvider from './Services/authProvider';
import { deepmerge } from '@mui/utils';
import MyLoginPage from './Screens/Login';
import { ProjectList } from './Screens/Projects/ProjectList';
import { ProjectEdit } from './Screens/Projects/ProjectEdit';
import { ProjectCreate } from './Screens/Projects/ProjectCreate';
import { Home } from './Screens/Home';
import { DatawarehouseScreen } from './Screens/Datawarehouse/DatawarehouseScreen';
import { BrowserRouter, Route } from 'react-router-dom';
import apiProvider from './Services/dataProvider';
import { UserCreate } from './Screens/Users/UserCreate';
import { UserEdit } from './Screens/Users/UserEdit';
import { UserList } from './Screens/Users/UserList';
import PeopleIcon from '@mui/icons-material/People';
import FactoryIcon from '@mui/icons-material/Factory';
import LocalOffer from '@mui/icons-material/LocalOffer';
import GroupsIcon from '@mui/icons-material/Groups';

import { orange, pink, red } from '@mui/material/colors'; // Import des couleurs MUI
import ProtectedRoute from './Components/Layout/ProtectedRoute';

//import { setLogLevel } from "firebase/app";
import { BillingAccountList } from './Screens/BillingAccounts/BillingAccountList';
import { BillingAccountEdit } from './Screens/BillingAccounts/BillingAccountEdit';
import { BillingAccountCreate } from './Screens/BillingAccounts/BillingAccountCreate';
import CustomLayout from './Components/Layout/Layout';
import { LogList } from './Screens/Logs/LogList';
import { LogView } from './Screens/Logs/LogView';
import { TwoFa } from './Screens/TwoFa/TwoFa';
import { ConnectorEdit } from './Screens/Connectors/ConnectorEdit';
import { ConnectorList } from './Screens/Connectors/ConnectorList';
import { ConnectorConfigHome } from './Screens/Connectors/ConnectorConfigHome';
import { ConnectorAccountCreate } from './Screens/ConnectorAccount/ConnectorAccountCreate';
import { ConnectorAccountsList } from './Screens/ConnectorAccount/ConnectorAccountList';
import { ConnectorAccountHome } from './Screens/ConnectorAccount/ConnectorAccountHome';
import { McpMemberList } from './Screens/McpMembers/McpMemberList';
import { McpMemberCreate } from './Screens/McpMembers/McpMemberCreate';
import { McpMemberEdit } from './Screens/McpMembers/McpMemberEdit';
import { AIEnrichmentsList } from './Screens/QuantiAI/AIEnrichmentsList';
import { AIUseCasesList } from './Screens/QuantiAI/AIUseCasesList';
import { AIUseCaseDetail } from './Screens/QuantiAI/AIUseCaseDetail';
import { AIConversationsList } from './Screens/QuantiAI/AIConversationsList';
import { AIConversationDetail } from './Screens/QuantiAI/AIConversationDetail';
import { AIFeedbackList } from './Screens/QuantiAI/AIFeedbackList';
import { AIFeedbackDetail } from './Screens/QuantiAI/AIFeedbackDetail';
import { AIAnalysesList } from './Screens/QuantiAI/AIAnalysesList';
import { SemanticCodesList } from './Screens/QuantiAI/SemanticCodesList';
import { MCPTestPage } from './Screens/QuantiAI/MCPTestPage';
import { AgentsOrgScreen } from './Screens/Agents/AgentsOrgScreen';
import { CredentialRequestsList } from './Screens/CredentialRequests/CredentialRequestsList';
import { LlmInstancesList } from './Screens/LlmInstances/LlmInstancesList';
import { ActivitiesList } from './Screens/Activities/ActivitiesList';
import { PlanList } from './Screens/Plans/PlanList';
import { PlanCreate } from './Screens/Plans/PlanCreate';
import { PlanEdit } from './Screens/Plans/PlanEdit';
import { FeatureList } from './Screens/Features/FeatureList';
import { FeatureCreate } from './Screens/Features/FeatureCreate';
import { FeatureEdit } from './Screens/Features/FeatureEdit';
import { SubscriptionList } from './Screens/Subscriptions/SubscriptionList';
import { OverrideList } from './Screens/EntitlementOverrides/OverrideList';
import { BillingAlerts } from './Screens/BillingAlerts';
import { ProductCatalog } from './Screens/Products/ProductCatalog';
import { ProductHolders } from './Screens/Products/ProductHolders';
import { OverrideCreate } from './Screens/EntitlementOverrides/OverrideCreate';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import ExtensionIcon from '@mui/icons-material/Extension';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import TuneIcon from '@mui/icons-material/Tune';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import PercentIcon from '@mui/icons-material/Percent';
import { PartnerList, PartnerEdit, PartnerCreate } from './Screens/Partners/Partners';
import { CommissionRateList, CommissionRateEdit } from './Screens/Partners/CommissionRates';
import { SignupRequestList } from './Screens/Partners/SignupRequests';
import { PayoutList, PayoutEdit } from './Screens/Partners/Payouts';
import { OpportunityList, OpportunityEdit, OpportunityCreate } from './Screens/Partners/Opportunities';
import { UseCaseList, UseCaseEdit, UseCaseCreate } from './Screens/Partners/UseCases';
import { UseCaseThemeList, UseCaseThemeEdit, UseCaseThemeCreate } from './Screens/Partners/UseCaseThemes';
import PaymentsIcon from '@mui/icons-material/Payments';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
//setLogLevel('debug');  // Active les logs de débogage

const myTheme = deepmerge(defaultTheme, {
	palette: {
		primary: {
			main: orange[900], // Couleur principale de la barre du haut
			light: orange[300], // Couleur pour les éléments plus clairs
			dark: orange[700], // Couleur pour les éléments plus foncés
			contrastText: '#fff', // Couleur du texte contrasté sur la barre du haut
		},
		secondary: {
			main: orange[900],
			light: pink[300],
			dark: pink[700],
			contrastText: '#fff',
		},
		error: {
			main: red[500],
			light: red[300],
			dark: red[700],
		},
		contrastThreshold: 3,
		tonalOffset: 0.2,
	},
	typography: {
		// Utilisation de la police de caractères système.
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Arial',
			'sans-serif',
		].join(','),
	},
});

const App = () => (
	<BrowserRouter>
		<Admin
			theme={myTheme}
			dataProvider={apiProvider}
			authProvider={authProvider}
			layout={CustomLayout}
			loginPage={MyLoginPage} // Utiliser la page de connexion personnalisée
		>
			<CustomRoutes>
				<Route path="/" element={<ProtectedRoute element={<Home />} />} />
			</CustomRoutes>
			<CustomRoutes>
				<Route path="/2fa" element={<ProtectedRoute element={<TwoFa />} />} />
			</CustomRoutes>
			{/* Pilotage de la mesure de consommation GCP : état de la synchro et
			    reprises. Pas une Resource react-admin — il n'y a pas de liste à
			    paginer, c'est un tableau de bord et deux boutons. */}
			<CustomRoutes>
				<Route
					path="/datawarehouse"
					element={<ProtectedRoute element={<DatawarehouseScreen />} />}
				/>
			</CustomRoutes>

			<Resource
				name="projects"
				list={ProjectList}
				create={ProjectCreate}
			/>
			<CustomRoutes>
				<Route
					path="/projects/:id/*"
					element={<ProtectedRoute element={<ProjectEdit />} />}
				/>
			</CustomRoutes>
			<Resource
				name="users"
				list={UserList}
				edit={UserEdit}
				create={UserCreate}
				icon={PeopleIcon}
			/>
			<Resource
				name="mcp-members"
				list={McpMemberList}
				create={McpMemberCreate}
				edit={McpMemberEdit}
				icon={GroupsIcon}
			/>
			<Resource
				name="billing-accounts"
				list={BillingAccountList}
				edit={BillingAccountEdit}
				create={BillingAccountCreate}
				icon={FactoryIcon}
			/>
			<Resource
				name="connectors"
				list={ConnectorList}
				icon={LocalOffer}
				edit={ConnectorEdit}
			/>
			<Resource
				name="connector-accounts"
				list={ConnectorAccountsList}
				create={ConnectorAccountCreate}
			/>
			<CustomRoutes>
				<Route
					path="/connector-accounts/:projectFolderId/:sku/:accountId/*"
					element={<ProtectedRoute element={<ConnectorAccountHome />} />}
				/>
				<Route
					path="/connectors/:id/config/*"
					element={<ProtectedRoute element={<ConnectorConfigHome />} />}
				/>
			</CustomRoutes>
			<Resource name="logs" list={LogList} show={LogView} />
			<Resource
				name="plans"
				list={PlanList}
				create={PlanCreate}
				edit={PlanEdit}
				icon={CardMembershipIcon}
			/>
			<Resource
				name="features"
				list={FeatureList}
				create={FeatureCreate}
				edit={FeatureEdit}
				icon={ExtensionIcon}
			/>
			<Resource
				name="subscriptions"
				list={SubscriptionList}
				icon={SubscriptionsIcon}
			/>
			<Resource
				name="entitlement-overrides"
				list={OverrideList}
				create={OverrideCreate}
				icon={TuneIcon}
			/>
			<CustomRoutes>
				<Route
					path="/billing-alerts"
					element={<ProtectedRoute element={<BillingAlerts />} />}
				/>
				<Route
					path="/products"
					element={<ProtectedRoute element={<ProductCatalog />} />}
				/>
				<Route
					path="/products/:product"
					element={<ProtectedRoute element={<ProductHolders />} />}
				/>
			</CustomRoutes>

			{/* Espace Partenaire */}
			{/* En tête du bloc : c'est une file d'attente. Une demande qui dort faute d'avoir
			    été vue est un partenaire qu'on perd, et rien d'autre ne la signale. */}
			<Resource
				name="partner-signup-requests"
				list={SignupRequestList}
				icon={HowToRegIcon}
				options={{ label: "Demandes d'accès" }}
			/>
			<Resource
				name="partners"
				list={PartnerList}
				edit={PartnerEdit}
				create={PartnerCreate}
				icon={HandshakeIcon}
			/>
			<Resource
				name="opportunities"
				list={OpportunityList}
				edit={OpportunityEdit}
				create={OpportunityCreate}
				icon={ContactPhoneIcon}
			/>
			<Resource
				name="use-cases"
				list={UseCaseList}
				edit={UseCaseEdit}
				create={UseCaseCreate}
				icon={LightbulbIcon}
			/>
			<Resource
				name="use-case-themes"
				list={UseCaseThemeList}
				edit={UseCaseThemeEdit}
				create={UseCaseThemeCreate}
				icon={LocalOfferIcon}
			/>
			<Resource
				name="commission-rates"
				list={CommissionRateList}
				edit={CommissionRateEdit}
				icon={PercentIcon}
			/>
			<Resource
				name="payouts"
				list={PayoutList}
				edit={PayoutEdit}
				icon={PaymentsIcon}
			/>

			{/* Quanti AI / MCP Public */}
			<CustomRoutes>
				<Route path="/ai-enrichments" element={<ProtectedRoute element={<AIEnrichmentsList />} />} />
				<Route path="/ai-use-cases" element={<ProtectedRoute element={<AIUseCasesList />} />} />
				<Route path="/ai-use-cases/:code" element={<ProtectedRoute element={<AIUseCaseDetail />} />} />
				<Route path="/ai-conversations" element={<ProtectedRoute element={<AIConversationsList />} />} />
				<Route path="/ai-conversations/:id" element={<ProtectedRoute element={<AIConversationDetail />} />} />
				<Route path="/ai-feedback" element={<ProtectedRoute element={<AIFeedbackList />} />} />
				<Route path="/ai-feedback/:id" element={<ProtectedRoute element={<AIFeedbackDetail />} />} />
				<Route path="/ai-analyses" element={<ProtectedRoute element={<AIAnalysesList />} />} />
				<Route path="/ai-semantic-codes" element={<ProtectedRoute element={<SemanticCodesList />} />} />
				<Route path="/agents" element={<ProtectedRoute element={<AgentsOrgScreen />} />} />
				<Route path="/mcp-test" element={<ProtectedRoute element={<MCPTestPage />} />} />
				<Route path="/credential-requests" element={<ProtectedRoute element={<CredentialRequestsList />} />} />
				<Route path="/llm-instances" element={<ProtectedRoute element={<LlmInstancesList />} />} />
				<Route path="/activities" element={<ProtectedRoute element={<ActivitiesList />} />} />
			</CustomRoutes>
		</Admin>
	</BrowserRouter>
);

export default App;
